import useTeamListContext from './context';
import TeamListProvider from './provider';

export { TeamListProvider };
export default useTeamListContext;
